import {
  AssignmentIndOutlined,
  AssignmentLateOutlined,
  AssignmentOutlined,
  AssignmentTurnedInOutlined,
} from '@mui/icons-material';
import TooltipOneComponent from '../../../components/TooltipOne/TooltipOne.component';
import { ExaminerFunction, VerificationState } from '../Assessment.types';

export const getVerificationStatusLabel = (
  verificationState: VerificationState,
  userFunction: ExaminerFunction,
): JSX.Element => {
  switch (verificationState) {
    case VerificationState.assigned:
      return (
        <TooltipOneComponent
          title={userFunction === ExaminerFunction.PZE ? 'Praca przypisana do weryfikatora' : 'Praca niezweryfikowana'}
          placement="top"
        >
          <AssignmentIndOutlined style={{ fill: ' #008000' }} />
        </TooltipOneComponent>
      );
    case VerificationState.noChanges:
      return (
        <TooltipOneComponent title="Praca zweryfikowana - brak zmian w ocenie" placement="top">
          <AssignmentOutlined style={{ fill: '#000000' }} />
        </TooltipOneComponent>
      );
    case VerificationState.pendingApproval:
      return (
        <TooltipOneComponent title="Praca zweryfikowana - czeka na zatwierdzenie PZE" placement="top">
          <AssignmentLateOutlined style={{ fill: ' #FF0000' }} />
        </TooltipOneComponent>
      );
    case VerificationState.scoreSelected:
      return (
        <TooltipOneComponent title="Praca zweryfikowana - zatwierdzona przez PZE" placement="top">
          <AssignmentTurnedInOutlined style={{ fill: '#228B22' }} />
        </TooltipOneComponent>
      );
    default:
      return <></>;
  }
};
